import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { CircularProgress } from "@mui/material";
import { Formik, Form } from "formik";
import { Button } from "components/haven-design";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";

import {
  UnitDisclaimers as Query,
  UnitDisclaimersVariables as QueryVars,
  UpdateDisclaimers as Mutation,
  UpdateDisclaimersVariables as MutationVars,
} from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import logger from "services/logger";
import { query, mutation } from "./queries";

type Props = { interestListId: string };

const fields = [
  { name: "sharedStatement", label: "Shared Statement" },
  { name: "br0Statement", label: "Studio/SRO Statement" },
  { name: "br1Statement", label: "1 BR Statement" },
  { name: "br1DenStatement", label: "1 BR + Den Statement" },
  { name: "br2Statement", label: "2 BR Statement" },
  { name: "br3Statement", label: "3 BR Statement" },
  { name: "br4Statement", label: "4 BR Statement" },
  { name: "br5Statement", label: "5 BR Statement" },
];

const SettingsUnitDisclaimers: React.FC<Props> = ({ interestListId }) => {
  const queryOpts = { variables: { id: interestListId } };
  const { data, loading, error } = useQuery<Query, QueryVars>(query, queryOpts);
  const [updateInterestList, { loading: sending }] = useMutation<Mutation, MutationVars>(mutation);
  const { openSnackbar } = useSnackbar();

  if (loading) return <CircularProgress />;
  if (error) return <div>Server error</div>;

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        sharedStatement: data?.interestList?.sharedStatement || "",
        br0Statement: data?.interestList?.br0Statement || "",
        br1Statement: data?.interestList?.br1Statement || "",
        br1DenStatement: data?.interestList?.br1DenStatement || "",
        br2Statement: data?.interestList?.br2Statement || "",
        br3Statement: data?.interestList?.br3Statement || "",
        br4Statement: data?.interestList?.br4Statement || "",
        br5Statement: data?.interestList?.br5Statement || "",
      }}
      onSubmit={async (values) => {
        try {
          await updateInterestList({ variables: { id: interestListId, data: values } });
          openSnackbar({ message: "Update Successful", status: "success" });
        } catch (e) {
          logger.sendError(e as Error);
          openSnackbar({ message: "Update failed", status: "error" });
        }
      }}
    >
      <Form>
        {fields.map(({ name, label }) => (
          <InputWithErrorLabel
            margin="none"
            key={name}
            name={name}
            label={label}
            style={{ margin: "0 20px 25px 0", width: "initial" }}
          />
        ))}
        <br />
        <Button type="submit" color="primary" size="L" disabled={sending}>
          Update
        </Button>
      </Form>
    </Formik>
  );
};

export default SettingsUnitDisclaimers;
